"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variationForBoolean = exports.FALSE_VARIATION_INDEX = exports.TRUE_VARIATION_INDEX = void 0;
exports.TRUE_VARIATION_INDEX = 0;
exports.FALSE_VARIATION_INDEX = 1;
/**
 * @internal
 */
function variationForBoolean(val) {
    return val ? exports.TRUE_VARIATION_INDEX : exports.FALSE_VARIATION_INDEX;
}
exports.variationForBoolean = variationForBoolean;
//# sourceMappingURL=booleanVariation.js.map